import React from 'react';

// Border effect types
export type BorderEffectType = 'black' | 'none' | 'gradient' | 'rgb';

// RGB moving light effect component - memoized to prevent re-creation
const RGBMovingLight: React.FC = React.memo(() => {
  const [position, setPosition] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prev) => (prev + 0.5) % 100);
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const createRGBGradient = React.useCallback(() => {
    const hue1 = (position * 3.6) % 360;
    const hue2 = ((position + 33.33) * 3.6) % 360;
    const hue3 = ((position + 66.66) * 3.6) % 360;
    
    return `linear-gradient(116deg, 
      hsl(${hue1}, 100%, 60%) 0%, 
      hsl(${hue2}, 100%, 60%) 33.33%, 
      hsl(${hue3}, 100%, 60%) 66.66%, 
      hsl(${hue1}, 100%, 60%) 100%)`;
  }, [position]);

  return (
    <div 
      className="w-1 h-full pointer-events-none overflow-hidden"
      style={{
        background: createRGBGradient(),
        boxShadow: '0 0 6px rgba(255, 255, 255, 0.2)'
      }}
    />
  );
});

RGBMovingLight.displayName = 'RGBMovingLight';

// Border effect component
export const BorderEffect: React.FC<{ type: BorderEffectType }> = ({ type }) => {
  switch (type) {
    case 'black':
      return (
        <div 
          className="w-1 h-full pointer-events-none" 
          style={{ background: "#000000" }}
        />
      );
    case 'gradient':
      return (
        <div 
          className="w-1 h-full pointer-events-none" 
          style={{ background: "linear-gradient(116deg, var(--Purple-1, #6E35FF) 0%, #30E38D 54.16%)" }}
        />
      );
    case 'rgb':
      return <RGBMovingLight />;
    case 'none':
    default:
      return null;
  }
};
